export default "__VITE_ASSET__DdR20WtH__"